

































import { computed, defineComponent, ref } from "@vue/composition-api";
import { Location } from "vue-router";
import { useStaticPages } from "@/hooks/useStaticPages";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "ComplianceContactsInfo",
  components: { BaseSpinner },
  setup() {
    const { pages, getPages } = useStaticPages();
    const loading = ref(false);
    const contactsPage = computed(() => pages.value.find(page => page.path === "/static/contact-us.html"));
    const isContactsPageVisible = computed(() => contactsPage.value?.visible ?? false);
    const contactsPageLink = computed(() => contactsPage.value?.path);
    // onlyfats: отмену подписки ведём на страницу Customer Service, а не в чат (CO-15525)
    const customerServicePage = computed(() =>
      pages.value.find(page => page.visible && /customer service/i.test(page.title))
    );
    const supportLink: Location = {
      name: "messages",
      params: {
        userId: "1",
      },
    };

    const getData = async () => {
      try {
        loading.value = true;
        await getPages();
      } finally {
        loading.value = false;
      }
    };

    getData();
    return { isContactsPageVisible, contactsPageLink, customerServicePage, supportLink, loading };
  },
});
